import { useRef, useState, useEffect } from "react";
import { IoArrowBackOutline, IoArrowForwardOutline } from "react-icons/io5";

export default function Paging({ page, plugin }) {
    
    const [pageNow, setpageNow] = useState(1);

    useEffect(() => {
        setpageNow(page);
    }, [page])
    
    return (
        <div className='bookPagingNav'>
            <a onClick={() => plugin.jumpToPreviousPage && plugin.jumpToPreviousPage()}>
                <IoArrowForwardOutline />
            </a>

            <input 
                type='number' 
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && pageNow.trim()) {
                        plugin.jumpToPage && plugin.jumpToPage(pageNow - 1);
                    }
                }}
                onChange={(e) => setpageNow(e?.target?.value)} value={pageNow} 
            />

            <a onClick={() => plugin.jumpToNextPage && plugin.jumpToNextPage()}>
                <IoArrowBackOutline />
            </a>
        </div>
    );
}